
import Cell from 'vux/src/components/cell/index.vue'


export default {
name:'InTitle',
data() {
return {
}
},
props: {
title: {
type: String,
default: ''
},
more: {
type: Boolean,
default: false
},
},
components: {
Cell,
},
methods: {
moreClick() {
this.$emit('moreClick')
},
},
}
